module.exports = __webpack_public_path__ + "static/img/news3.7705972.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/news3.png
// module id = 38uA
// module chunks = 2